<template>
  <Dialog 
    hideModalButtons
    center
    size="extra-large"
    :title="$route.query.name"
    :customClose="close"
  >
    <img :src="$route.query.url" alt="zoomed file" class="zoomed-file"/>
  </Dialog>
</template>
<script>
import Dialog from '@/components/Dialog';
import ModalMixin from '@/mixins/ModalMixin';

export default {
  name: 'file-modal',
  mixins: [ModalMixin],
  components: { Dialog },
  methods: {
    close() {
      this.$router.go(-1);
    },
  }
};
</script>
<style>
body {
}
.zoomed-file {
  display: flex;
  margin: 0 auto;
  max-width: 100%;
  position: relative;
  max-height: calc(90vh - /*headier height*/57px - /*padding height*/40px);
}
</style>



// WEBPACK FOOTER //
// src/modals/File.vue